import React, { useState } from 'react';
import './CareerPath.css';

const CareerPath = () => {
  const tabs = [
    'Career Pathways in Digital Marketing',
    'Salary for Digital Marketers in India',
    'Key Steps on How to Get Jobs in Digital Marketing in India',
  ];

  const [activeTab, setActiveTab] = useState(tabs[0]);

  const renderContent = () => {
    switch (activeTab) {
      case tabs[0]:
        return (
          <>
            <p>
              Digital marketing is one of the fastest-growing fields, offering a wide range of career opportunities for professionals with the right skills. Whether you're a fresher or someone looking to switch careers, this industry offers dynamic roles that blend creativity, strategy, and analytics. By enrolling in a digital marketing course in India, you'll gain practical, in-demand skills that are highly sought after across all sectors.
            </p>
            <h4>1. <span className="highlight">SEO Specialist</span></h4>
            <p>
              <strong>Job Role:</strong> An <span className="highlight">SEO Specialist</span> helps websites rank higher in search engine results. Responsibilities include content optimization, keyword research, and building high-quality backlinks to increase organic traffic.
            </p>

            <h4>2. <span className="highlight">Social Media Manager</span></h4>
            <p>
              <strong>Job Role:</strong> A <span className="highlight">Social Media Manager</span> creates and manages content across platforms like Instagram, Facebook, LinkedIn, and Twitter. They drive brand awareness, engagement, and lead generation through organic and paid strategies.
            </p>

            <h4>3. <span className="highlight">PPC Specialist</span></h4>
            <p>
              <strong>Job Role:</strong> A <span className="highlight">PPC (Pay-Per-Click) Specialist</span> designs and manages online ad campaigns using tools like Google Ads. They aim to maximize return on investment by targeting the right audience and analyzing performance metrics.
            </p>
          </>
        );

      case tabs[1]:
        return (
          <>
            <p>
              The salary of digital marketing professionals in India varies based on experience, skills, and job role. With the country's growing startup culture and digital adoption, competitive pay scales are common across metros and tier-2 cities.
            </p>
            <ul>
              <li><strong>Entry-Level (0–2 years):</strong> ₹2.5L – ₹4.5L per annum</li>
              <li><strong>Mid-Level (3–5 years):</strong> ₹5L – ₹9L per annum</li>
              <li><strong>Senior-Level (5+ years):</strong> ₹10L – ₹20L+ per annum</li>
            </ul>
            <p>
              Specialists such as SEO Analysts, PPC Managers, and Content Strategists may earn higher based on performance and niche expertise.
            </p>
          </>
        );

      case tabs[2]:
        return (
          <>
            <p>
              Want to land a digital marketing job in India? Here’s a practical roadmap to help you break into this booming field:
            </p>
            <ol>
              <li><strong>1. Learn the Fundamentals:</strong> Choose a structured course that covers SEO, Google Ads, Social Media, Content Marketing, Email Marketing, and Analytics.</li>
              <li><strong>2. Build a Real Portfolio:</strong> Work on your own blog, YouTube channel, or freelance projects to showcase your skills.</li>
              <li><strong>3. Get Certified:</strong> Earn certifications from Google, HubSpot, Meta, or SEMrush to add credibility to your resume.</li>
              <li><strong>4. Craft a Job-Ready Resume:</strong> Focus on results, tools used, and actual metrics (like leads generated or traffic increased).</li>
              <li><strong>5. Apply Smartly:</strong> Use job portals like Naukri, Indeed, and LinkedIn. Reach out to digital marketing agencies or startups directly.</li>
            </ol>
            <p>
              Bonus tip: Join communities, attend webinars, and keep updating your skills to stay ahead in this ever-evolving industry.
            </p>
          </>
        );

      default:
        return null;
    }
  };

  return (
   <div style={{padding:20}}>
     <div className="career-container">
      <h2 className="section-title">Benefits of Learning Digital Marketing Course from Arrow Digital?</h2>
      <div className="tab-section">
        {tabs.map((tab) => (
          <div
            key={tab}
            className={`tab-item ${activeTab === tab ? 'active' : ''}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </div>
        ))}
      </div>
      <div className="content-section">
        {renderContent()}
      </div>
    </div>
   </div>
  );
};

export default CareerPath;
